import { __extends, __rest } from "tslib";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "./PnmacChatAvatar.styles.js";
import { Image, Text, TouchableOpacity, View, Platform } from "react-native";
var PnmacChatAvatar = /** @class */function (_super) {
  __extends(PnmacChatAvatar, _super);
  function PnmacChatAvatar(props) {
    return _super.call(this, props) || this;
  }
  PnmacChatAvatar.prototype.setAvatarColor = function () {
    var userName = this.props.user.name || "";
    var name = userName.toUpperCase().split(" ");
    if (name.length === 1) {
      this.avatarName = "".concat(name[0].charAt(0));
    } else if (name.length > 1) {
      this.avatarName = "".concat(name[0].charAt(0)).concat(name[1].charAt(0));
    } else {
      this.avatarName = "";
    }
    var sumChars = 0;
    for (var i = 0; i < userName.length; i++) {
      sumChars += userName.charCodeAt(i);
    }
    // colors from https://flatuicolors.com/
    var colors = ["#e67e22", "#2ecc71", "#3498db", "#8e44ad", "#e74c3c", "#1abc9c", "#2c3e50" // midnight blue
    ];
    this.avatarColor = colors[sumChars % colors.length];
  };
  PnmacChatAvatar.prototype.renderAvatar = function () {
    var layout = this.props.layout;
    if (typeof this.props.user.avatar === "function") {
      return this.props.user.avatar();
    } else if (typeof this.props.user.avatar === "string") {
      if (this.props.user.avatar == "pennyIcon") {
        return /*#__PURE__*/React.createElement(Image, {
          style: {
            width: 50,
            height: 50
          },
          source: layout.isPrivateLabel ? require('../assets/townsgate-avatar-1.png') : require('../assets/ChatHeader.png')
        });
      }
      return /*#__PURE__*/React.createElement(Image, {
        source: this.props.user.avatar
      });
    }
    return null;
  };
  PnmacChatAvatar.prototype.renderInitials = function () {
    return /*#__PURE__*/React.createElement(Text, {
      style: [styles.textStyle, this.props.textStyle]
    }, this.avatarName);
  };
  PnmacChatAvatar.prototype.render = function () {
    var _this = this;
    var _a, _b;
    if (!((_a = this.props.user) === null || _a === void 0 ? void 0 : _a.name) && !((_b = this.props.user) === null || _b === void 0 ? void 0 : _b.avatar)) {
      // render placeholder
      return /*#__PURE__*/React.createElement(View, {
        testID: "chat_avatar",
        style: [styles.avatarStyle, {
          backgroundColor: "transparent"
        }, this.props.avatarStyle],
        accessibilityTraits: "image"
      });
    }
    if (this.props.user.avatar) {
      return /*#__PURE__*/React.createElement(TouchableOpacity, {
        testID: "chat_avatar",
        disabled: this.props.onPress ? false : true,
        onPress: function () {
          var _a = _this.props,
            onPress = _a.onPress,
            other = __rest(_a, ["onPress"]);
          _this.props.onPress && _this.props.onPress(other);
        },
        accessibilityTraits: "image"
      }, this.renderAvatar());
    }
    if (!this.avatarColor) {
      this.setAvatarColor();
    }
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      testID: "chat_avatar",
      disabled: this.props.onPress ? false : true,
      onPress: function () {
        var _a = _this.props,
          onPress = _a.onPress,
          other = __rest(_a, ["onPress"]);
        _this.props.onPress && _this.props.onPress(other);
      },
      style: [styles.avatarStyle, {
        backgroundColor: "#003087"
      }, this.props.avatarStyle],
      accessibilityTraits: "image"
    }, this.renderInitials());
  };
  return PnmacChatAvatar;
}(React.Component);
PnmacChatAvatar.defaultProps = {
  user: {
    name: null,
    avatar: null
  },
  onPress: null,
  avatarStyle: {},
  textStyle: {}
};
PnmacChatAvatar.propTypes = {
  user: PropTypes.object,
  onPress: PropTypes.func,
  avatarStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  textStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string])
};
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
export default connect(mapStateToProps)(PnmacChatAvatar);